$(document).ready(function () {

    //UI events
    $(window).on('resize', function (){
        resizeSdsBox();
    });

    applyURLQueryParameters();

    $("#mi-corpo-sds-search-button").on('click', function () {
        countryVal = $('#country').val();
        languageVal = $('#language').val();

        if (countryVal == "" || countryVal == null || languageVal == "" || languageVal == null) {
            $('#searchErrorMessageFields').removeClass("VisuallyHidden");
        }
        else {
            $('#searchErrorMessageFields').addClass("VisuallyHidden");
            $("#mi-corpo-elcaSafetyDataSheet-loading-img").css("display", "block");
            showResults();
        }
        
    });

    $("#references, #country, #language").on("change", function () {
        var url = GenerateQueryParameters();
        window.history.pushState({},"",url);
    });

});

function showResults() {
    $("input[name*='reseller']").remove().trigger("change");
    var queryParameters =
        ($('#references').val() || $('#country').val() || $('#language').val() ? '?' : '') +
        ($('#references').val() ? '&reference='+ $('#references').val() : '') +
        ($('#country').val() ? '&countryCode='+ $('#country').val() : '') +
        ($('#country').val() ? '&countryName='+  document.getElementById('country').options[$('#country').prop("selectedIndex")].text : '') +
        ($('#language').val() ? '&lang='+ $('#language').val() : '');
    resizeSdsBox();
    renderAsyncRequest('/sds/search', queryParameters, '#mi-corpo-sds-display-results');
}

function resizeSdsBox() {
    if ($(".mi-corpo-sds-results").html().length > 0 && $(".mi-corpo-sds-detail-modal").html()) {
        if (  $(".mi-corpo-sds-detail-modal").html().length <= 0) {
            $(window).width() >= 992 ?
                $(".mi-corpo-safety-data-sheets").height(540) :
                $(".mi-corpo-safety-data-sheets").height(800);
        }
    }
}

function renderAsyncRequest(url, queryParameters, domElementToChange, language="en") {
    $.ajax({
        url: url + queryParameters,
        dataType: 'html',
        data: {language: language },
        success: function(data) {
			if (domElementToChange != null) {
				$(domElementToChange).html(data);
			}
        }
    });
}

function applyURLQueryParameters() {
    if (getParameterByName("reference")){
        var reference = getParameterByName("reference").toUpperCase();
        $('#references').val(reference);
    }

    if (getParameterByName("countryCode")){
        var country = getParameterByName("countryCode").toUpperCase();
        $('#country').val(country);
    }

    if (getParameterByName("language")) {
        var language = getParameterByName("language").toUpperCase();
        $('#language').val(language);
    }

    if (getParameterByName("reference") || getParameterByName("countryCode") || getParameterByName("language")) {
        showResults();
    }
    

}

getParameterByName = function (name) {
    name = name.replace(/[\[]/, "\[").replace(/[\]]/, "\]");
    var regex = new RegExp("[\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results !== null ? decodeURIComponent(results[1].replace(/\+/g, " ")) : '';
};

function GenerateQueryParameters() {
    var queryParameters =
        ($('#references').val() || $('#country').val() || $('#language').val() ? '?' : '') +
        ($('#references').val() ? 'reference=' + $('#references').val() : '') +
        ($('#country').val() ? $('#references').val() ? '&countryCode=' + $('#country').val() : 'countryCode=' + $('#country').val(): '') +
        ($('#language').val() ? ($('#references').val() || $('#country').val()) ? '&language=' + $('#language').val() : 'language=' + $('#language').val() :'');

    var URL = location.protocol + '//' + location.host + location.pathname + queryParameters;

    return URL;
}